<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">


      <search-items v-model="search"></search-items>

<!--      <div class="text-right btngroup">
        <CButton
            class="deleteBtn">
          Delete
        </CButton>
        <router-link class="btn addBtn ml-2" to="/products/add" tag="button">Create</router-link>
      </div>-->
    </div>

    <b-table
        :items="translations"
        :fields="fields"
        hover
        sorter
        show-empty
    >
      <template #cell(actions)="item">
        <edit class="mr-2" @click="openModal(item)" :id="item.item.id" fillColor="#009FE3"/>
      </template>
      <template #empty="">
        No data exists
      </template>
    </b-table>
    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
    ></b-pagination>

    <b-modal id="translation-modal" size="lg" no-close-on-backdrop hide-footer @hide="hideModel">
      <template #modal-title>
        <span>Edit Translation</span>
      </template>
      <div class="row">
        <div class="col-md-12">
          <b-form-group
              label="Translation Key"
              labelClass="required"
          >
            <b-form-input
                type="text"
                placeholder="Translation Key"
                v-model="form.trans_key"
                name="trans_key"
                disabled
                v-validate="{required: true}"
            ></b-form-input>
            <div v-if="errors && errors.first('trans_key')" class="error_msg">
              Field translation key is required
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12 mt-3">
          <b-form-group
              label="Translation"
              labelClass="required"
          >
            <b-form-input
                type="text"
                placeholder="Translation"
                v-model="form.trans_value"
                name="trans_value"
                v-validate="{required: true}"
            ></b-form-input>
            <div v-if="errors && errors.first('trans_value')" class="error_msg">
              {{ errors.first('trans_value') }}
            </div>
          </b-form-group>
        </div>
        <div class="col-12 text-right mt-3">
          <b-button variant="primary" @click="updateOrCreate">Save</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Edit from 'vue-material-design-icons/Pencil.vue';
import { http } from "@/config/httpCommon";
import SearchItems from "../../components/SearchItems";
import {getPageModal, removePageModal, setPageModal} from "@/helpers/Helpers";

const fields = [
  {key: 'index', label: 'Sr#'},
  {key: 'trans_key', label: 'Translation Key'},
  {key: 'trans_value', label: 'Translation'},
  {key: 'actions'},
]
export default {
  components: {
    Edit,
    SearchItems
  },
  async created() {
    try {
      await this.$store.commit('set', ['showLoader', true]);
      this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getTranslations)
      await this.$store.commit('set', ['showLoader', false]);
    } catch (error) {
      await this.$store.commit('set', ['showLoader', false]);
      this.showToast(error.messaage, 'DANGER');
    }
  },
  data() {
    return {
      fields,
      search:'',
      translations: [],
      form: {
        id: null,
        trans_key: null,
        trans_value: null,
      },
      current_record: null,
      pagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
    }
  },
  methods: {
    async getTranslations(payload) {
      let res = await this.$store.dispatch('getTranslations', payload);
      this.translations = res.data.data;
      this.makePagination(res.data.meta)
    },
    handlePagination(page=''){
      let params = '?page='+page;
      if(this.search) {
        params += '&search='+this.search
      }
      setPageModal(page,this.$route.name,this.search);
      this.getTranslations(params);
    },
    makePagination(data){
      this.pagination.currentPage = data.current_page;
      this.pagination.rows = data.total;
      this.pagination.perPage = data.per_page;
      this.pagination.total = data.total;
    },
    openModal(item = null) {
      if (item) {
        this.current_record = item.index;
        this.form.id = item.item.id;
        this.form.trans_key = item.item.trans_key;
        this.form.trans_value = item.item.trans_value;
      }
      this.$bvModal.show("translation-modal");
    },
    hideModel(){
      this.update_index = null;
    },
    async updateOrCreate(){
      let self = this;
      let valid = await this.$validator.validate();
      if(valid){
        this.$store.commit('set', ['showLoader', true]);
        if(this.form.id){
          console.log(self.translations);
          await http.patch(`company-translations/${this.form.id}`, this.form).then(() => {
            self.translations[self.current_record].trans_key = self.form.trans_key;
            self.translations[self.current_record].trans_value = self.form.trans_value;
            this.preservePagination( 'page', 'search', this.$route.name, this.getTranslations)
          }).catch(error => {
            console.error("Error while updating translation", error)
          });
        }
        this.$store.commit('set', ['showLoader', false]);
        this.$bvModal.hide("translation-modal");
      }
    }
  }
}
</script>